require('./angular-animate');
module.exports = 'ngAnimate';



// WEBPACK FOOTER //
// ./src/libs/angular-animate/index.js